module.exports = __webpack_public_path__ + "img/off_line_monitor.b2619cd9.jpeg";